import { clear } from './clear';
import getCount from './utils/getCount';

// ----------------------------------------------------------------------------

function refresh(element: HTMLElement, config: Record<string, any> = {}): void {
    const count = getCount(element);

    if (count.rowCount > 0) {
        const elTableEmpty = element.querySelector<HTMLElement>('.table-empty');

        if (elTableEmpty && count.rowCount > 1) {
            elTableEmpty.parent()?.remove();
        }
    } else {
        clear(element, config);
    }
}

// ----------------------------------------------------------------------------

export { refresh };
